module.exports = __webpack_public_path__ + "static/img/step2@2x.787b7717.png";